import type { ReactNode } from "react";

export default function StoryRing({
  unseen,
  children,
}: {
  unseen: boolean;
  children: ReactNode;
}) {
  return (
    <span
      data-story-ring-state={unseen ? "unseen" : "seen"}
      className={`flex h-16 w-16 items-center justify-center rounded-full p-[3px] ${
        unseen
          ? "bg-[linear-gradient(135deg,#6D28D9_0%,#9333EA_52%,#C084FC_100%)]"
          : "bg-[linear-gradient(135deg,#CBD5E1_0%,#DDD6FE_52%,#C4B5FD_100%)]"
      }`}
    >
      <span className="flex h-full w-full items-center justify-center overflow-hidden rounded-full border-2 border-white bg-violet-50 text-sm font-bold text-[#4c1d95]">
        {children}
      </span>
    </span>
  );
}
